import request from '@/utils/request'

let Complaints_complaintsApi = {

  /*投诉列表*/
  list(data) {
    return request._post('/shop/plus.complaints_complaints.Index/index', data);
},
/*添加投诉*/
add(data) {
    return request._post('/shop/plus.complaints_complaints.Index/add', data);
},
/*修改投诉*/
edit(data) {
    return request._post('/shop/plus.complaints_complaints.Index/edit', data);
},
/*删除投诉*/
del(data) {
    return request._post('/shop/plus.complaints_complaints.Index/del', data);
},
getCategory(data){
    return request._post('/shop/plus.complaints_complaints.Category/getCategory', data);
},

  catDel(data) {
        return request._post('/shop/plus.complaints_complaints.Category/delete', data);
    },
        catAdd(data) {
            return request._post('/shop/plus.complaints_complaints.category/add', data);
        },
        catEdit(data) {
                return request._post('/shop/plus.complaints_complaints.category/edit', data);
            },
       catList(data) {
            return request._post('/shop/plus.complaints_complaints.Category/indexx', data);
        },
        /*分
/*投诉详情*/
detail(data) {
  return request._post('/shop/plus.complaints_complaints.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.complaints_complaints.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.complaints_complaints.Setting/getSetting', data, errorback);
    },
}
export default Complaints_complaintsApi;



// WEBPACK FOOTER //
// ./src/api/complaints_complaints.js